'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsibleSidePanel = undefined;

var _CollapsibleSidePanel2 = require('./CollapsibleSidePanel');

var _CollapsibleSidePanel3 = _interopRequireDefault(_CollapsibleSidePanel2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CollapsibleSidePanel = _CollapsibleSidePanel3.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvcGFuZWwvaW5kZXguanN4Il0sIm5hbWVzIjpbIkNvbGxhcHNpYmxlU2lkZVBhbmVsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBQU9BLG9CIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IENvbGxhcHNpYmxlU2lkZVBhbmVsIGZyb20gJy4vQ29sbGFwc2libGVTaWRlUGFuZWwnO1xuIl19